import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["primary", "secondary"]

  switch(event) {
    event.preventDefault()

    this.primaryTarget.classList.toggle("hidden")
    this.secondaryTarget.classList.toggle("hidden")

    // Focus the input in the newly visible form
    const visibleForm = this.primaryTarget.classList.contains("hidden")
      ? this.secondaryTarget
      : this.primaryTarget

    const input = visibleForm.querySelector("input[type='email'], input[type='tel']")
    if (input) {
      input.focus()
    }
  }
}
